<div class="gs-workspace-scroll h-full overflow-y-auto overflow-x-hidden">
  <gridstack [options]="gridOptions()" (changeCB)="onGridChange($event)" (dragStartCB)="onGridDragStart($event)" (dragStopCB)="onGridDragStop($event)" (resizeStopCB)="onGridItemResized($event)" (removedCB)="onGridItemRemoved()" (addedCB)="onGridItemAdded($event)">
    @for (item of workspace()?.uiComponents; track item.id) {
      <gridstack-item [options]="toGridItem(item)" (mouseenter)="getActiveComponent(item.id)" (mouseleave)="clearActiveComponent()">
        <div class="flex justify-between items-center workspace-cmp-header flex-shrink-0 bg-[var(--p-content-hover-background)]">
          <div class="drag-handler flex-1 overflow-hidden text-ellipsis whitespace-nowrap cursor-grab active:cursor-grabbing">
            {{ item.name }}
            {{ stringDependentComponents().includes(item.name) ? (!item.name.startsWith('Drill String') ? currentStringName() : holeSectionName()) : '' }}
          </div>
          <div class="flex items-center">
            @if (item.name === componentInstance()) {
              <span class="pi pi-save text-green-400 pb-1 pr-1"></span>
            }
            <p-button class="p-0" size="small" severity="danger" icon="pi pi-times"
              (click)="componentRemoved.emit(item)">
            </p-button>
          </div>
        </div>
        <fieldset class="border-none m-0 no-drag gs-item-content min-w-0" [disabled]="userRoles()?.readOnly">
          <ndc-dynamic
            [ndcDynamicComponent]="item.componentInstance"
            [ndcDynamicInputs]="{ componentId: item.id }">
          </ndc-dynamic>
        </fieldset>
      </gridstack-item>
    }
  </gridstack>
</div>